import { TokenDataBox } from "./views/tokenDataBox";
import './style/tokenData.css'
import { tokenDataService } from "./services/tokenData.service";

const tokenDataHandler = async () => {
    const tokenDataContainer = document.getElementById('token-data-container');
    if (!tokenDataContainer) { return; }

    const tokenSlug = tokenDataContainer.getAttribute('data-token-slug')
    if (!tokenSlug) { throw new Error('Token slug not found') }

    const tokenData = await tokenDataService.getTokenData(tokenSlug)
    if (tokenData.length === 0) { throw new Error('No token data found') }

    new TokenDataBox(tokenDataContainer, tokenData[0])
    tokenDataContainer.style.display = 'flex'
}

document.addEventListener('DOMContentLoaded', tokenDataHandler);